import { makeStyles } from "@material-ui/core/styles";
import { useIsAr } from "../../../../../../Hooks";

export default makeStyles((theme) => {
  const { isAr } = useIsAr(theme.direction);

  return {
    timelineContentWrapper: {
      ...(isAr ? { paddingRight: "12px" } : { paddingLeft: "12px" }),
      marginBottom: "16px",
    },
    activityCard: {
      ...(isAr
        ? { padding: "12px 24px 12px 6px" }
        : { padding: "12px 6px 12px 24px" }),
      display: "flex",
      justifyContent: "space-between",
      position: "relative",
      gap: "12px",
      [theme.breakpoints.down("md")]: {
        maxWidth: "600px",
        [theme.breakpoints.down("xs")]: {
          maxWidth: "229px",
        },
      },
    },
    activityInfoContainer: {
      display: "flex",
      width: "100%",
      gap: "96px",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        gap: "6px",
      },
    },
    leftSection: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "18px",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
        [theme.breakpoints.down("xs")]: {
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "12px",
        },
      },
    },
    iconWrapper: {
      background: theme.palette.background.tertiary,
      borderRadius: "50%",
      width: 40,
      height: 40,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    nameStatusContainer: {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
      width: "max-content",
      gap: "10px",
      [theme.breakpoints.down("xs")]: {
        marginBottom: "8px",
        maxWidth: "fit-content",
      },
    },
    activityName: {
      color: theme.palette.text.primary,
      fontSize: "16px",
      fontWeight: "700",
      lineHeight: "24px",
    },
    rightSection: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      gap: "10px",
      width: "100%",
    },
    divider: {
      backgroundColor: theme.palette.border.secondary,
    },
    createdAssignedContainer: {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    infoItem: {
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "20px",
      gap: "6px",
      display: "flex",
      alignItems: "flex-start",
      fontSize: "14px",
      color: theme.palette.text.primary,
    },
    createdbyAssignedtoValue: {
      wordWrap: "break-word",
      whiteSpace: "normal",
      overflow: "hidden",
      fontWeight: "600",
      lineHeight: "20px",
      fontSize: "14px",
      color: theme.palette.text.primary,
    },
    arrowIcon: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    commentContainer: {
      display: "flex",
      gap: "6px",
      justifyContent: "space-between",
      padding: "6px 0px 0px 0px",
      alignItems: "start",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    commentValue: {
      whiteSpace: "pre-wrap",
      overflow: "hidden",
      color: theme.palette.text.text_quarterary,
      textOverflow: "ellipsis",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
    },
    menuActiveIconClass: {
      fill: theme.palette.foreground.quarterary,
      cursor: "pointer",
      position: "absolute",
      ...(isAr ? { left: "6px" } : { right: "6px" }),
      top: "12px",
    },
    menuDefaultIconClass: {
      fill: theme.palette.foreground.quinary,
      cursor: "pointer",
      position: "absolute",
      ...(isAr ? { left: "6px" } : { right: "6px" }),
      top: "12px",
    },
    prefixContentWrapper: {
      width: "65px",
      marginInlineEnd: "20px",
      [theme.breakpoints.down("xs")]: {
        width: "53px",
      },
    },
    prefixItemMonth: {
      color: theme.palette.foreground.disabled_subtle,
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "28px",
      [theme.breakpoints.down("xs")]: {
        width: "65px",
      },
    },
    prefixItemYear: {
      color: theme.palette.foreground.disabled_subtle,
      fontWeight: 700,
      fontSize: "20px",
      lineHeight: "30px",
      [theme.breakpoints.down("xs")]: {
        width: "50px",
      },
    },
    prefixItemTime: {
      color: theme.palette.foreground.disabled_subtle,
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px",
      [theme.breakpoints.down("xs")]: {
        width: "55px",
      },
    },
  };
});
